<template>
  <div class='font-icon' @click='$emit("click")' :class='iconClass'>{{ iconName }}</div>
</template>

<script>
export default {
  name: 'font-icon',
  props: {
    type: {
      type: String,
      default: 'material-icons'
    },
    name: {
      type: String,
      required: true
    },
    pClass: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: 'normal'
    },
    LuClick: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    iconClass: function () {
      let c = { }
      if (this.pClass) {
        c[this.pClass] = true
      }
      if (this.type === 'material-icons') {
        c['material-icons'] = true
      }
      else if (this.type === 'element-icons') {
        c[this.name] = true
      }
      else if (this.type === 'font-awesome') {
        c['fas'] = true
        c['fa-' + this.name] = true
      }
      else if (this.type === 'webtrader') {
        c['icon-wt' + this.name[0].toUpperCase() + this.name.substr(1)] = true
      }
      else if (this.type === 'wt') {
        c['wtIcon wt-' + this.name] = true
      }
      c['size-' + this.size] = true
      if (this.LuClick) c['lu-click'] = true
      return c
    },
    iconName: function () {
      if (this.type === 'material-icons') {
        return this.name
      }
      else if (this.type === 'text') {
        return this.name
      }
      else {
        return ''
      }
    }
  }
}
</script>

<style scoped lang='scss'>
.font-icon {
  vertical-align: middle;
  align-self: center;

    // &:hover {
    //   -webkit-filter: invert(100%);
    //   filter: invert(100%);
    // }

}

.font-icon.size-xxlarge {
  font-size: 2.5rem;
}

.font-icon.size-xlarge {
  font-size: 2.3rem !important;
}

.font-icon.size-medium {
  font-size: 2rem !important;
}

.font-icon.size-base {
  font-size: 1.5rem !important;
}

.font-icon.size-small {
  font-size: 1.3rem !important;
}

.font-icon.size-mini {
  font-size: 1.1rem !important;
}

.font-icon.size-xxsmall {
  font-size: 0.9rem;
}

.font-icon.convert {
  transform: rotate(90deg);
}

.font-icon.convert45 {
  transform: rotate(-45deg);
}


</style>